module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-maker-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReady),
      expression: "!isReady"
    }],
    staticClass: "logo-maker-loader"
  }, [_c('div', {
    staticClass: "loader"
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker",
    style: ({
      visibility: _vm.isReady ? 'visible' : 'hidden'
    })
  }, [_c('div', {
    staticClass: "logo-maker-menu"
  }, [_c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerText"
    }
  }, [_vm._v("Название вашей фирмы")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "logo-maker-menu__form-control",
    attrs: {
      "id": "logoMakerText",
      "type": "text",
      "placeholder": "Название вашей фирмы"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "focus": function($event) {
        _vm.openToolbox('text')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toolbox === 'text'),
      expression: "toolbox === 'text'"
    }],
    staticClass: "logo-maker-toolbox",
    attrs: {
      "id": "textToolbox"
    }
  }, [_c('sketch-picker', {
    on: {
      "change-color": _vm.changeColorText
    },
    model: {
      value: (_vm.textColors),
      callback: function($$v) {
        _vm.textColors = $$v
      },
      expression: "textColors"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-toolbox__close",
    on: {
      "click": function($event) {
        _vm.toolbox = ''
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 64 64",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "enable-background": "new 0 0 64 64"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"
    }
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerFont"
    }
  }, [_vm._v("\n          Шрифт названия\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__fontstyle"
  }, [_c('label', {
    staticClass: "logo-maker-menu__fontstyle-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textBold),
      expression: "textBold"
    }],
    staticClass: "logo-maker-menu__fontstyle-checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": !(_vm.font.Bold && (_vm.textItalic ? _vm.font.BoldItalic : true))
    },
    domProps: {
      "checked": Array.isArray(_vm.textBold) ? _vm._i(_vm.textBold, null) > -1 : (_vm.textBold)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.textBold,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.textBold = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.textBold = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.textBold = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo-maker-menu__fontstyle-icon"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "width": "16px",
      "height": "16px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 16 16",
      "enable-background": "new 0 0 16 16",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M10.3,7.8c0.8,0.2,2.2,0.5,2.2,2c0,0.6-0.2,1.1-0.7,1.5c-0.6,0.5-1.4,0.7-2.6,0.7h-4v-0.2c0.4,0,0.6,0,0.7-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.4,0.1-0.8V5.4c0-0.4,0-0.7-0.1-0.8C6.2,4.5,6.1,4.4,6,4.4C5.8,4.3,5.6,4.3,5.2,4.3V4H9C10,4,10.6,4.1,11,4.3c0.4,0.2,0.7,0.4,0.9,0.7c0.2,0.3,0.3,0.7,0.3,1c0,0.4-0.1,0.7-0.4,1C11.5,7.4,11,7.6,10.3,7.8z M8.2,8.1l0,2.8c0,0.2,0.1,0.4,0.2,0.5s1.1,0,1.3,0c1-0.2,1.5-2.2,0.2-2.9C9.6,8.3,8.8,8.1,8.2,8.1z M8.2,7.6c0.6,0,1.9-0.2,1.9-1.2c0-2-1-1.9-1.9-1.9V7.6z"
    }
  })])])])]), _vm._v(" "), _c('label', {
    staticClass: "logo-maker-menu__fontstyle-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textItalic),
      expression: "textItalic"
    }],
    staticClass: "logo-maker-menu__fontstyle-checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": !(_vm.font.Italic && (_vm.textBold ? _vm.font.BoldItalic : true))
    },
    domProps: {
      "checked": Array.isArray(_vm.textItalic) ? _vm._i(_vm.textItalic, null) > -1 : (_vm.textItalic)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.textItalic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.textItalic = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.textItalic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.textItalic = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo-maker-menu__fontstyle-icon"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "width": "16px",
      "height": "16px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 16 16",
      "enable-background": "new 0 0 16 16",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M8.3,11.8L8.3,12H5l0.1-0.2c0.3,0,0.5,0,0.6-0.1c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.2,0.3-0.5,0.4-1l1.4-4.8C8,5.3,8.1,5,8.1,4.8c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.3-0.1-0.6-0.1l0.1-0.2h3.1l-0.1,0.2c-0.2,0-0.4,0-0.6,0.1C9.5,4.4,9.3,4.6,9.3,4.7C9.2,4.8,9,5.2,8.9,5.7l-1.4,4.8c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.2C7.8,11.7,8,11.8,8.3,11.8z"
    }
  })])])])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textStyle.fontFamily),
      expression: "textStyle.fontFamily"
    }],
    staticClass: "logo-maker-menu__form-control",
    attrs: {
      "id": "logoMakerFont",
      "type": "text",
      "placeholder": "Шрифт названия"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.textStyle.fontFamily = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.stopPropagation();
        _vm.changeFont(this)
      }]
    }
  }, _vm._l((_vm.fonts), function(font) {
    return _c('option', [_vm._v(_vm._s(font.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerTheme"
    }
  }, [_vm._v("Тематика")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theme),
      expression: "theme"
    }],
    staticClass: "logo-maker-menu__form-control",
    attrs: {
      "id": "logoMakerTheme",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.theme = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.themes), function(name, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(" " + _vm._s(name) + " ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerIcon"
    }
  }, [_vm._v("Иконка")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-icons"
  }, _vm._l((_vm.icons), function(url, i) {
    return _c('div', {
      staticClass: "logo-maker-icons__item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.icon),
        expression: "icon"
      }],
      staticClass: "logo-maker-icons__radio",
      attrs: {
        "type": "radio",
        "id": 'logoMakerIcon_' + i
      },
      domProps: {
        "value": i,
        "checked": _vm._q(_vm.icon, i)
      },
      on: {
        "__c": function($event) {
          _vm.icon = i
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "logo-maker-icons__icon",
      attrs: {
        "for": 'logoMakerIcon_' + i
      },
      on: {
        "click": function($event) {
          _vm.openToolbox('icon')
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": "",
        "src": _vm.getIconUrl(i),
        "width": "32",
        "height": "32"
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toolbox === 'icon'),
      expression: "toolbox === 'icon'"
    }],
    staticClass: "logo-maker-toolbox",
    attrs: {
      "id": "icnToolbox"
    }
  }, [_c('sketch-picker', {
    on: {
      "change-color": _vm.changeColorIcon
    },
    model: {
      value: (_vm.iconColors),
      callback: function($$v) {
        _vm.iconColors = $$v
      },
      expression: "iconColors"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-toolbox__close",
    on: {
      "click": function($event) {
        _vm.toolbox = ''
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 64 64",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "enable-background": "new 0 0 64 64"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"
    }
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('div', {
    staticClass: "logo-maker-menu__half",
    staticStyle: {
      "width": "65%"
    }
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerIcon"
    }
  }, [_vm._v("Положение")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons"
  }, [_c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconPosition),
      expression: "iconPosition"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "left",
      "id": "logoMakerIconPosition_left"
    },
    domProps: {
      "checked": _vm._q(_vm.iconPosition, "left")
    },
    on: {
      "__c": function($event) {
        _vm.iconPosition = "left"
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconPosition),
      expression: "iconPosition"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "top",
      "id": "logoMakerIconPosition_top"
    },
    domProps: {
      "checked": _vm._q(_vm.iconPosition, "top")
    },
    on: {
      "__c": function($event) {
        _vm.iconPosition = "top"
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconPosition),
      expression: "iconPosition"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "right",
      "id": "logoMakerIconPosition_right"
    },
    domProps: {
      "checked": _vm._q(_vm.iconPosition, "right")
    },
    on: {
      "__c": function($event) {
        _vm.iconPosition = "right"
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconPosition),
      expression: "iconPosition"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "bottom",
      "id": "logoMakerIconPosition_bottom"
    },
    domProps: {
      "checked": _vm._q(_vm.iconPosition, "bottom")
    },
    on: {
      "__c": function($event) {
        _vm.iconPosition = "bottom"
      }
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__half",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerIcon"
    }
  }, [_vm._v("Размер")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons"
  }, [_c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconScale),
      expression: "iconScale"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "0.75",
      "id": "logoMakerIconPosition_075"
    },
    domProps: {
      "checked": _vm._q(_vm.iconScale, "0.75")
    },
    on: {
      "__c": function($event) {
        _vm.iconScale = "0.75"
      }
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconScale),
      expression: "iconScale"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "1",
      "id": "logoMakerIconPosition_1"
    },
    domProps: {
      "checked": _vm._q(_vm.iconScale, "1")
    },
    on: {
      "__c": function($event) {
        _vm.iconScale = "1"
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-uicons__item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iconScale),
      expression: "iconScale"
    }],
    staticClass: "logo-maker-uicons__radio",
    attrs: {
      "type": "radio",
      "value": "1.5",
      "id": "logoMakerIconPosition_15"
    },
    domProps: {
      "checked": _vm._q(_vm.iconScale, "1.5")
    },
    on: {
      "__c": function($event) {
        _vm.iconScale = "1.5"
      }
    }
  }), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-menu__item"
  }, [_c('label', {
    staticClass: "logo-maker-menu__label",
    attrs: {
      "for": "logoMakerIcon"
    }
  }, [_vm._v("Рамка")]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-icons logo-maker-icons--shape",
    staticStyle: {
      "max-height": "197px"
    }
  }, _vm._l((_vm.shapes), function(i) {
    return _c('div', {
      staticClass: "logo-maker-icons__item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.shape),
        expression: "shape"
      }],
      staticClass: "logo-maker-icons__radio",
      attrs: {
        "type": "radio",
        "id": 'logoMakerShape_' + i
      },
      domProps: {
        "value": i,
        "checked": _vm._q(_vm.shape, i)
      },
      on: {
        "__c": function($event) {
          _vm.shape = i
        }
      }
    }), _vm._v(" "), (i == 'none') ? _c('label', {
      staticClass: "logo-maker-icons__icon",
      attrs: {
        "for": 'logoMakerShape_' + i
      }
    }, [_c('div', {
      staticStyle: {
        "width": "45px",
        "height": "45px",
        "color": "#000",
        "font-weight": "bold",
        "line-height": "45px",
        "text-align": "center"
      }
    }, [_vm._v("Нет")])]) : _c('label', {
      staticClass: "logo-maker-icons__icon",
      attrs: {
        "for": 'logoMakerShape_' + i
      }
    }, [_c('img', {
      attrs: {
        "alt": "",
        "src": 'static/shapes/' + i + '.svg',
        "width": "42",
        "height": "42"
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-workarea-wrap"
  }, [_c('div', {
    staticClass: "logo-maker-workarea",
    attrs: {
      "id": "logoMakerWorkarea"
    }
  }, [_c('svg', {
    staticClass: "logo-maker-svg"
  }, [_c('g', {
    staticClass: "logo-maker-svg__inner"
  }, [_c('text', {
    style: ({
      fontWeight: _vm.textBold ? 'bold' : 'normal',
      fontStyle: _vm.textItalic ? 'italic' : 'normal',
      fontSize: _vm.textStyle.fontSize,
      fontFamily: '\'' + _vm.textStyle.fontFamily + '\''
    }),
    attrs: {
      "text-anchor": "middle",
      "fill": _vm.textColor,
      "transform": _vm.textTransform
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (!_vm.hasShape()) ? _c('g', {
    staticClass: "icon-wrap",
    attrs: {
      "transform": _vm.iconTransform,
      "fill": _vm.iconColor
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconHTML)
    }
  }) : _c('g', {
    staticClass: "icon-wrap",
    attrs: {
      "transform": _vm.iconTransform,
      "fill": _vm.iconColor
    }
  }, [_c('g', {
    attrs: {
      "transform": "matrix(0.8, 0, 0, 0.8, 22, 22)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconHTML)
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "x": "0",
      "y": "0",
      "transform": "matrix(1, 0, 0, 1, 0, 0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.shapePath)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "logo-maker-info"
  }, [_c('div', {
    staticClass: "logo-maker-get-logo"
  }, [_c('button', {
    staticClass: "logo-maker-get-logo__btn",
    on: {
      "click": _vm.getLogo
    }
  }, [_vm._v("Забрать свой логотип")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "520px"
    }
  }, [_vm._v("\n          Конструктор логотипов - инструмент, который позволит вам создать профессиональный логотип вашей компании в считанные минуты - даже если у вас нет навыков работы в графических редакторах.\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_left"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_left.svg",
      "alt": "left",
      "title": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_top"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_top.svg",
      "alt": "top",
      "title": "top"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_right"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_right.svg",
      "alt": "left",
      "title": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_bottom"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_bottom.svg",
      "alt": "bottom",
      "title": "bottom"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_075"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_size1.svg",
      "alt": "0.75",
      "title": "0.75"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_1"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_size2.svg",
      "alt": "1",
      "title": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "logo-maker-uicons__label",
    attrs: {
      "for": "logoMakerIconPosition_15"
    }
  }, [_c('img', {
    staticClass: "logo-maker-uicons__icon",
    attrs: {
      "src": "static/ui-icons/ui_size3.svg",
      "alt": "1.5",
      "title": "1.5"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-274a0122"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 99
// module chunks = 1